import React from 'react';
import './SettingsPopup.css';

interface SettingsPopupProps {
  children: React.ReactNode;
  width?: number | string;
  className?: string;
}

const SettingsPopup: React.FC<SettingsPopupProps> = ({
  children,
  width = 322,
  className = '',
}) => (
  <div className={`settings-popup ${className}`} style={{ width }}>
    {children}
  </div>
);

export default SettingsPopup;
